import Message from "../../../i18n/Message";
import NewWorkspaceLayout from "../layout/NewWorkspaceLayout";
import { useDispatch, useSelector } from "react-redux";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { loadVendorKeys } from "./store/vendorKeyActionCreators";
import { vendorKeySelectors } from "./store/vendorKeyReducer";
import ModelVendors from "../../../model/model-providers/modelVendors";
import VendorKeyTile from "./VendorKeyTile";

import "./VendorKeyListPage.scss";

const VendorKeyListPage = () => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const { workspaceId } = useParams();
  const [showCreate, setShowCreate] = useState(false);
  const keyList = useSelector(vendorKeySelectors.getList);
  const listCounter = useSelector(vendorKeySelectors.getListCounter);

  useEffect(() => {
    if (workspaceId) {
      dispatch(loadVendorKeys(intl, workspaceId));
    }
  }, [dispatch, intl, workspaceId, listCounter]);

  return (
    <NewWorkspaceLayout contentPanelClassName="vendor_keys_main">
      <div className="body_content card">
        <div className="content_header">
          <h1>
            <Message id="vendor_keys_title" />
          </h1>
          <div className="model_vendors">
            {Object.values(ModelVendors).map((vendor) => (
              <div key={vendor}>
                <VendorKeyTile vendorKey={vendor} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </NewWorkspaceLayout>
  );
};

export default VendorKeyListPage;
